import React from "react";
import PaymentBuilderGeneral from "./PaymentBuilderGeneral";
import PaymentLogNotes from "./PaymentLogNotes";

class PaymentBuilderWorkspace extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    if (this.props.activeTab === 'general') {
      return (
        <PaymentBuilderGeneral {...this.props} />
      );
    } else if (this.props.activeTab === 'notes') {
      return <PaymentLogNotes {...this.props} />
    };
  };
};

export default PaymentBuilderWorkspace